// lib/theme.ts

export function loadThemeFromStorage() {
	const theme = localStorage.getItem("theme");
	const html = document.documentElement;

	if (theme === "dark") html.classList.add("dark");
	else html.classList.remove("dark");
}

export function toggleTheme() {
	const html = document.documentElement;
	const isDark = html.classList.toggle("dark");
	localStorage.setItem("theme", isDark ? "dark" : "light");
}
